import React from 'react';

import { apiExamples, apiMethods, apiSections } from '../content/apiContent';

export const ApiInstructionContent: React.FC = () => (
  <>
    <div className="instruction__section">
      <div className="instruction__section-title">Общая информация</div>
      <p className="instruction__paragraph">
        Базовый путь для вызовов API: <code>https://expert.fintarget.ru/api/</code>
      </p>
      <p className="instruction__paragraph">
        Все данные передаются в формате <code>{apiExamples.contentType}</code>.
      </p>
      <p className="instruction__paragraph">
        Для актуальных методов используйте заголовок <code>apiKey</code> как уникальный ключ стратегии. Для части
        устаревших методов ключ ещё передается в теле запроса.
      </p>
      <p className="instruction__paragraph">Дополнительные типы данных в описании: `decimal` и `int`.</p>
    </div>

    <div className="instruction__section">
      <div className="instruction__section-title">Основные методы</div>
      <ul className="instruction__list">
        {apiMethods.map((item) => (
          <li key={item.method}>
            <code>{item.method}</code> — {item.description}
          </li>
        ))}
      </ul>
    </div>

    {apiSections.map((section) => (
      <div className="instruction__section" key={section.request}>
        <div className="instruction__section-title">{section.title}</div>
        <p className="instruction__paragraph">
          <code>{section.request}</code>
        </p>
        <p className="instruction__paragraph">{section.summary}</p>
        {section.headers && (
          <>
            <div className="instruction__section-subtitle">Headers</div>
            <pre className="instruction__code">{section.headers}</pre>
          </>
        )}
        {section.body && (
          <>
            <div className="instruction__section-subtitle">Body</div>
            <pre className="instruction__code">{section.body}</pre>
          </>
        )}
        {section.response && (
          <>
            <div className="instruction__section-subtitle">Ответ</div>
            <pre className="instruction__code">{section.response}</pre>
          </>
        )}
      </div>
    ))}
  </>
);
